import React from 'react';
import { Content, Header, Page } from '@backstage/core-components';
import { SearchType } from '@backstage/plugin-search';
import {
  SearchBar,
  SearchResult,
  SearchPagination,
} from '@backstage/plugin-search-react';
import { CatalogSearchResultListItem } from '@backstage/plugin-catalog';

const SearchPage = () => {
  return (
    <Page themeId="home">
      <Header title="Search" />
      <Content>
        <SearchBar />
        <SearchType.Tabs
          defaultValue="software-catalog"
          types={[
            {
              value: 'software-catalog',
              name: 'Software Catalog',
            },
          ]}
        />
        <SearchPagination />
        <SearchResult>
          <CatalogSearchResultListItem icon={<div />} />
        </SearchResult>
      </Content>
    </Page>
  );
};

export const searchPage = <SearchPage />;
